import { createRoute, redirect } from '@tanstack/react-router';
// fallow-ignore-next-line circular-dependency -- co-located route modules must import the pathless parent; the cycle is EntityQuickFind → routeTree → routes.tsx → this module → route.tsx and already exists for every migrated route.
import { Route as pathlessAuthenticatedRoute } from '../../route';

/** Backfills moved under Admin → Maintenance; keep old links and bookmarks working. */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/admin/backfills',
  beforeLoad: () => {
    throw redirect({ to: '/admin/maintenance/backfills' });
  },
});
